import { Component, OnInit, OnDestroy,Pipe,PipeTransform} from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Page,PageService } from './page.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title,BrowserModule,DomSanitizer,SafeHtml} from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { MetaService } from 'ng2-meta';
import { CopyWriteService} from './../services/copywrite.service';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    console.log(this.sanitized.bypassSecurityTrustHtml(value))
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

interface PageData {
  title: string;
  description: SafeHtml;
  
  meta_title: string;
  meta_description: string;  
}
var sitename;
@Component({    
	
	//template: require('./page.component.html')
	templateUrl: './pg/page/page.component.html'
		
})


export class PageComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
	public subpage:Array<any>;
    public metadescription;
   
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private _sanitizer: DomSanitizer,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private copywriteservice:CopyWriteService,
	    private _pageService: PageService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}
		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh hhhnaga";
	   // alert("page");
	  this.slimLoadingBarService.start();
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			
			 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);				   
			   
			   this._pageService.getPage(slug).subscribe(
        data => {
                 // 
                                   
                  this.pagedata.title=data.page.page_name;
                  //this.pagedata.description=this.transform(data.page.page_content) ; 
                  this.pagedata.description=this.transform(data.page.page_content); 
                  this.subpage=data.page.sub_page;                               
                //  this.pagedata.description=this._sanitizer.bypassSecurityTrustHtml(this.pagedata.description) SafeHtml;
                  
                  
                  //this.metatitle=;
                  
                  if(data.page.meta_title)
                  {
	                  this._title.setTitle(data.page.meta_title);
	                  this.metaService.setTag('og:title',data.page.meta_title);
	                  //this.metaService.setTag('title',data.page.meta_title);
	                  //this.metaService.setTag('og:description',data.page.meta_description);
                  }
                  
                  else
                  this._title.setTitle(data.page.page_name);
                  
                  if(data.page.meta_description)
                  this.metaService.setTag('description',data.page.meta_description);
                  
                  this.metaService.setTag('keywords',data.page.meta_keywords);
                                    
                 // this.metaService.setTag('og:title',data.page.page_name);
                 // this.metaService.setTag('og:description',data.page.page_content);
                  
					//  this.metaService.setTag('og:url','p/'+data.page.slug);
					  
		
                
                 setTimeout(()=>{    //<<<---    using ()=> syntax
         
                
			      let copywrite=this.shareService.getcopywrite();  
			      //console.log("Mydata->"+this.siteinfo.site_address);        
			      this.copywriteservice.copywritelogo(copywrite);
				  },1000);
				  
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
               this.slimLoadingBarService.complete();
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}
     public transform(value: string): SafeHtml {
		return this._sanitizer.bypassSecurityTrustHtml(value);

	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/page/page.component.ts